const STATES = {
  INITIAL: 'initial',
  TRUNCATED: 'truncated',
  EXTENDED: 'extended'
};

export { STATES };
